import React, { useEffect, useState } from 'react';

import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom'
import PositionedSnackbar from "../../components/general/PositionedSnackbar";
import { useDispatch } from 'react-redux'
import Config from '../../config'
import GeneralStyles from '../GeneralStyles.module.scss'
import CustomLoaderSpinner from "../../components/general/CustomLoaderSpinner";
import PageHeader from "../../components/general/PageHeader";
import CustomTextFieldNative from "../../components/general/CustomTextFieldNative";
import Colors from "../../config/colors";
import SearchIcon from '@mui/icons-material/Search';
import Constants from "../../config/constants";
import Styles from './styles/WorkOrders.module.scss';
import WorkOrdersList from '../../metadata/work_orders.json'
import moment from "moment";
import Helpers from "../../utils/helpers";
import SortableList, { SortableItem } from 'react-easy-sort'
import { arrayMoveImmutable } from 'array-move'
import {STATES} from '../../metadata/enums'

import {
	fetchWorkOrders,
	updateActiveUnderwriting,
	fetchOneWorkOrder,
	updateActiveUnderwritingId
} from "../../redux/slices/workOrdersSlice";
import {
	API_CALL_STATUS,
	WORK_ORDER_STATUSES,
	URGENCY_OPTIONS,
	WORK_ORDER_STATUS_OPTIONS,
	PROPERTY_CATEGORY_OPTIONS,
	PROPERTY_STATUS_OPTIONS,
	WORK_ORDER_TYPE_OPTIONS
} from "../../metadata/enums";
import {getAssumptionsSettings, updateSettingsUpdatedStatus} from "../../redux/slices/settingsSlice";
import {changeUserAccess} from "../../redux/slices/authSlice";
import CustomModal from "../../components/general/CustomModal";
import { liteClient as algoliasearch } from 'algoliasearch/lite';
import {Configure, Highlight, Hits, InstantSearch, SearchBox} from 'react-instantsearch';
import ResponsivePagination from 'react-responsive-pagination';
import SortIcon from '@mui/icons-material/Sort';
import CustomSelect from "../../components/general/CustomSelect";
import CustomButtonContained from "../../components/general/CustomButtonContained";
import CustomTextFieldNew from "../../components/general/CustomTextFieldNew";


const searchClient = algoliasearch(Config.ALGOLIA_APP_ID, Config.ALGOLIA_SEARCH_KEY);

const DEFAULT_SEARCH_FILTER = [
	{label: 'Updated At', value: 'work_order_updated_at', order: -1},
	{label: 'Created At', value: 'work_order_created_at', order: -1},
	{label: 'Cost', value: 'work_order_cost', order: -1},
]

const DEFAULT_FIELD_FILTERS = [
	{label: 'Urgency', value: 'work_order_urgency', filter: null},
	{label: 'Work Order Status', value: 'work_order_status', filter: null},
	{label: 'Property Category', value: 'property_category', filter: null},
	{label: 'Property Status', value: 'property_status', filter: null},
	{label: 'Work Order Type', value: 'work_order_type', filter: null},
	{label: 'Property State', value: 'property_address_region', filter: null}
]

export default function WorkOrders() {
	let dispatch = useDispatch()
	let navigate = useNavigate()

	const user = useSelector(state => {return state.user})
	const token = useSelector(state => state.auth.token)
	const workOrdersState = useSelector(state => state.workOrders)
	const newWorkOrdersPageCount = useSelector(state => state.auth.new_work_orders_pages)
	const engagingWorkOrdersPageCount = useSelector(state => state.auth.engaging_work_orders_pages)
	const ignoredWorkOrdersPageCount = useSelector(state => state.auth.ignored_work_orders_pages)

	const [items, setItems] = React.useState(DEFAULT_SEARCH_FILTER)


	const [currentPage, setCurrentPage] = useState(1)
	const [showSearchModal, setShowSearchModal] = useState(false)
	const [showSortModal, setShowSortModal] = useState(false)
	const [searchString, setSearchString] = useState('')
	const [tab, setTab] = useState(0)
	const [loading, setLoading] = useState(false)
	const [showError, setShowError] = useState(false)
	const [errorMessage, setErrorMessage] = useState('')
	const [workOrders, setWorkOrders] = useState([])
	const [sortFilter, setSortFilter] = useState({work_order_updated_at: -1})
	const [fieldFilterOptions, setFieldFilterOptions] = useState(DEFAULT_FIELD_FILTERS)
	const [fieldFilters, setFieldFilters] = useState(null)
	const [workOrderCostFilters, setWorkOrderCostFilters] = useState(null)
	const [workOrderMin, setWorkOrderMin] = useState('')
	const [workOrderMax, setWorkOrderMax] = useState('')

	useEffect(() => {
		if(workOrdersState.status === API_CALL_STATUS.LOADING) {
			setLoading(true)
		} else if(workOrdersState.status === API_CALL_STATUS.FAILED) {
			setErrorMessage(`${workOrdersState.error}. Please contact support if the problem persists.`)
			setShowError(true)
		} else {
			setLoading(false)
			if(workOrdersState.work_orders)
				setWorkOrders(workOrdersState.work_orders)

		}
	},[workOrdersState])

	useEffect(() => {
		if(token) {
			let dispatchObject = {token, page: currentPage, sort: sortFilter, filter: fieldFilters, workOrderCostFilters}
			if(tab === 0)
				dispatchObject['status'] = WORK_ORDER_STATUSES.NEW
			else if(tab === 1)
				dispatchObject['status'] = WORK_ORDER_STATUSES.ENGAGING
      else if(tab === 2)
				dispatchObject['status'] = WORK_ORDER_STATUSES.IGNORED

			dispatch(fetchWorkOrders(dispatchObject))
		}
	}, [token, tab, currentPage, sortFilter, fieldFilters, workOrderCostFilters]);


	const onSearchStringChanged = (txt) => {
		setSearchString(txt)
	}

	const renderFilterRow = () => {
		return (
			<div style={{width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
				<div
					onClick={() => setShowSearchModal(true)}
					style={{width: '62%', backgroundColor: Colors.theme, borderRadius: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', paddingLeft: 20}}>
					<SearchIcon size={22} style={{color: 'white'}}/>
					<CustomTextFieldNative
						containerStyle={{width: '100%'}}
						height={36}
						label={'search'}
						placeholder={'Search the work orders'}
						value={searchString}
						onChange={() => setShowSearchModal(true)}/>
				</div>

				<SortIcon style={{color: Colors.theme, cursor: 'pointer', marginLeft: 20, height: 30, width: 30}} onClick={() => setShowSortModal(true)} />

				<div style={{width: '38%', display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>
					<Tab tab={tab} onChange={(value) => {
						setItems(DEFAULT_SEARCH_FILTER)
						setCurrentPage(1)
						setTab(value)
					}}/>
				</div>
			</div>
		)
	}

	const renderList = () => {
		let list = workOrders
		let elements = list.map((item, index) => {
			let tags = JSON.parse(item.work_order_tags).join(', ')
			return (
				<div
					className={`${GeneralStyles.row}`}
					key={item._id}
					style={{borderBottom: `thin solid ${Colors.tableLineColor}`, cursor: 'pointer', padding: '6px 0px 6px 0px'}}
					onClick={() => {
						dispatch(updateActiveUnderwritingId(item._id))
						dispatch(updateActiveUnderwriting(item))
						navigate('/home/underwriting-details')
					}}
				>
					<ListItem title={item._id} width={'5%'} marginLeft={0}/>
					<ListItem title={item.work_order_subject} width={'15%'} marginLeft={4}/>
					<Status status={item.status} width={'5%'} marginLeft={4}></Status>
					<ListItem title={item.work_order_urgency} width={'5%'} marginLeft={4}/>
					<ListItem title={`$${Helpers.getFormattedNumber(item.work_order_cost || 0)}`} width={'6%'} marginLeft={4}/>
					<ListItem title={item.work_order_type} width={'10%'} marginLeft={4}/>
					<ListItem title={item.property_address_display} width={'16%'} marginLeft={4}/>
					<ListItem title={item.property_address_region} width={'4%'} marginLeft={4}/>
					<ListItem title={item.property_category} width={'10%'} marginLeft={4} breakWord={true}/>
					<ListItem title={item.property_status} width={'8%'} marginLeft={4} breakWord={true}/>
					<ListItem title={item?.lease_end_date ? moment(item.lease_end_date).format('MM/DD/YY') : 'N/A'} width={'8%'} marginLeft={4}/>
					<ListItem title={moment(item.work_order_updated_at).format('MM/DD/YY')} width={'8%'} marginLeft={4}/>

				</div>
			)
		})
		return (
			<div className={Styles.listContainer}>
				<div className={`${GeneralStyles.row}`}>
					<Header title={'ID'} width={'5%'} marginLeft={0}/>
					<Header title={'Subject'} width={'15%'} marginLeft={4}/>
					<Header title={'Type'} width={'5%'} marginLeft={4}/>
					<Header title={'Urgency'} width={'5%'} marginLeft={4}/>
					<Header title={'Cost'} width={'6%'} marginLeft={4}/>
					<Header title={'Work Order Type'} width={'10%'} marginLeft={4}/>
					<Header title={'Address'} width={'16%'} marginLeft={4}/>
					<Header title={'Address'} width={'4%'} marginLeft={4}/>
					<Header title={'Category'} width={'10%'} marginLeft={4}/>
					<Header title={'Status'} width={'8%'} marginLeft={4}/>
					<Header title={'Move Out'} width={'8%'} marginLeft={4}/>
					<Header title={'Updated'} width={'8%'} marginLeft={4}/>
				</div>

				<div style={{height: '90%', overflowY: 'scroll'}}>
					{elements.length > 0 ?
						elements
						:
						<p style={{marginTop: 20, width: '100%', textAlign: 'center'}}>Nothing to display</p>
					}
				</div>


			</div>
		)
	}

	const renderSearchModal = () => {
		function Hit({ hit }) {
			return (
				<div
					onClick={() => {
						setShowSearchModal(false)
						dispatch(updateActiveUnderwritingId(hit._id))
						dispatch(updateActiveUnderwriting(hit))
						// dispatch(fetchOneWorkOrder({token, _id: hit._id}))
						navigate('/home/underwriting-details')
					}}
					style={{width: window.innerWidth - 300, padding: '10px 0px', cursor: 'pointer'}}>
					<div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
						<label className={Styles.searchModalLabel}>WO ID: </label>
						<p className={Styles.searchModalEntry}><Highlight attribute="_id" hit={hit} /></p>
					</div>
					<div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
						<label className={Styles.searchModalLabel}>Subject: </label>
						<p className={Styles.searchModalEntry}><Highlight attribute="work_order_subject" hit={hit} /></p>
					</div>
					<div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
						<label className={Styles.searchModalLabel}>Description: </label>
						<p className={Styles.searchModalEntry}><Highlight attribute="work_order_description" hit={hit} /></p>
					</div>
					<div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
						<label className={Styles.searchModalLabel}>Address: </label>
						<p className={Styles.searchModalEntry}><Highlight attribute="property_address_display" hit={hit} /></p>
					</div>
				</div>
			);
		}

		return (
			<CustomModal
				show={showSearchModal}
				handleClose={() => {
					setShowSearchModal(false)
				}}
				containerWidth={window.innerWidth - 200}
				containerHeight={window.innerHeight - 100}
			>
				<div style={{
					width: '100%',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					height: '100%',
					padding: '0px 10px',
					overflowY: 'scroll'
				}}>
					<h3 className={GeneralStyles.darkText}>Search Work Orders</h3>
					<InstantSearch searchClient={searchClient} indexName="work_orders" style={{width: '90%'}}>
						<Configure hitsPerPage={50} />
						<SearchBox style={{width: '50%'}} placeholder={'Search work orders'}/>
						<Hits hitComponent={Hit} />
					</InstantSearch>
				</div>
			</CustomModal>
		)
	}

	const onSortEnd = (oldIndex, newIndex) => {
		setItems((array) => arrayMoveImmutable(array, oldIndex, newIndex))
	}

	const onSortConfirmed = () => {
		let temp = {}
		items.forEach((item, index) => {
      temp[item.value] = item.order
    })

		let temp2 = {}
		fieldFilterOptions.forEach((option) => {
			if(option.filter) {
				temp2[option.value] = option.filter.map(value => value.label)
			}
		})

		let temp3 = {}
		if(workOrderMin && workOrderMin.length > 0)
			temp3['min'] = workOrderMin
		if(workOrderMax && workOrderMax.length > 0)
			temp3['max'] = workOrderMax

		setCurrentPage(1)
		setSortFilter(temp)
		setFieldFilters(temp2)
		setWorkOrderCostFilters(temp3)
		setShowSortModal(false)
	}

	const renderSortModal = () => {
		const sortOptions = [{label: 'Ascending', value: 1}, {label: 'Descending', value: -1}]
		const urgencyOptions = URGENCY_OPTIONS.map(option => ({label: option, value: option}))
		const statusOptions = WORK_ORDER_STATUS_OPTIONS.map(option => ({label: option, value: option}))
		const propertyCategoryOptions = PROPERTY_CATEGORY_OPTIONS.map(option => ({label: option, value: option}))
		const propertyStatusOptions = PROPERTY_STATUS_OPTIONS.map(option => ({label: option, value: option}))
		const workOrderTypeOptions = WORK_ORDER_TYPE_OPTIONS.map(option => ({label: option, value: option}))
		const stateOptions = STATES.map(option => ({label: option, value: option}))
		return (
			<CustomModal
				show={showSortModal}
				handleClose={() => {
					setShowSortModal(false)
				}}
				containerWidth={window.innerWidth/2.5}
				containerHeight={window.innerHeight - 80}
			>
				<div style={{
					width: '100%',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					height: '100%',
					position: 'relative',
          overflowY: 'scroll'
				}}>
					<h3 className={GeneralStyles.darkText} style={{textDecoration: 'underline'}}>Sort & Filter</h3>

					<p className={GeneralStyles.darkText} style={{fontSize: Constants.headerSize, fontWeight: 'bold'}}>Sort Order</p>
					<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%', justifyContent: 'center'}}>
						<SortableList onSortEnd={onSortEnd} className={Styles.list} draggedItemClassName={Styles.dragged}>
							{items.map((item) => (
								<SortableItem key={item.label}>
									<div className={Styles.item}>{item.label}</div>
								</SortableItem>
							))}
						</SortableList>
						<div style={{width: '30%'}}>
							{
								items.map((item, index) => (
									<div
										className={GeneralStyles.boxShadow}
										style={{width: 200, height: 40, borderRadius: 10, marginLeft: 20, marginTop: 10, marginBottom: 10}}>
										<CustomSelect
											isSearchable={false}
											placeholder={'select order'}
											borderColor={'transparent'}
											value={item.order === -1 ? sortOptions[1] : sortOptions[0]}
											options={sortOptions}
											onChange={(selected) => {
												let temp = [...items]
												temp[index].order = selected.value
												setItems(temp)
												// setLoanFeeOption(selected)
												// if(selected?.value === 0)
												// 	setLoanFee(Number(assumptions?.pricing?.loan_fee?.fixed).toFixed(2));
												// else
												// 	setLoanFee(Number(assumptions?.pricing?.loan_fee?.percent).toFixed(2));
											}}
										/>
									</div>
								))
							}
						</div>
					</div>

					<p className={GeneralStyles.darkText} style={{fontSize: Constants.headerSize, fontWeight: 'bold', marginTop: 20, padding: '0px 10px'}}>Filter Fields</p>
					<div style={{display: 'flex', flexDirection: 'row', alignItems: 'row', width: '94%', marginTop: 10}}>
						<label className={GeneralStyles.darkText} style={{width: 210}}>Work Order Cost</label>
						<CustomTextFieldNew
							width={200}
							label={`Minimum ($)`}
							placeholder={`enter minimum cost`}
							value={workOrderMin}
							onChange={(text) => {
								if (Helpers.checkIfNumber(text)) {
									setWorkOrderMin(text)
								}
							}}
						/>

						<CustomTextFieldNew
							marginLeft={25}
							width={200}
							label={`Maximum ($)`}
							placeholder={`enter maximum cost`}
							value={workOrderMax}
							onChange={(text) => {
								if (Helpers.checkIfNumber(text)) {
									setWorkOrderMax(text)
								}
							}}
						/>
					</div>
					<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', width: '94%', marginTop: 10}}>
						<label className={GeneralStyles.darkText} style={{width: 200}}>Work Order Type</label>
						<div
							className={GeneralStyles.boxShadow}
							style={{width: '70%', minHeight: 40, borderRadius: 10, marginLeft: 10,}}>
							<CustomSelect
								isMulti={true}
								isSearchable={false}
								placeholder={'select'}
								borderColor={'transparent'}
								value={fieldFilterOptions[4].filter}
								options={workOrderTypeOptions}
								onChange={(selected) => {
									let temp = [...fieldFilterOptions]
									temp[4].filter = selected
									setFieldFilterOptions(temp)
								}}
							/>
						</div>
					</div>

					<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', width: '94%', marginTop: 10}}>
						<label className={GeneralStyles.darkText} style={{width: 200}}>Work Order Urgency</label>
						<div
							className={GeneralStyles.boxShadow}
							style={{width: '70%', minHeight: 40, borderRadius: 10, marginLeft: 10,}}>
							<CustomSelect
								isMulti={true}
								isSearchable={false}
								placeholder={'select'}
								borderColor={'transparent'}
								value={fieldFilterOptions[0].filter}
								options={urgencyOptions}
								onChange={(selected) => {
                  let temp = [...fieldFilterOptions]
                  temp[0].filter = selected
                  setFieldFilterOptions(temp)
                }}
							/>
						</div>
					</div>

					<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', width: '94%', marginTop: 10}}>
						<label className={GeneralStyles.darkText} style={{width: 200}}>Work Order Status</label>
						<div
							className={GeneralStyles.boxShadow}
							style={{width: '70%', minHeight: 40, borderRadius: 10, marginLeft: 10,}}>
							<CustomSelect
								isMulti={true}
								isSearchable={false}
								placeholder={'select'}
								borderColor={'transparent'}
								value={fieldFilterOptions[1].filter}
								options={statusOptions}
								onChange={(selected) => {
									let temp = [...fieldFilterOptions]
									temp[1].filter = selected
									setFieldFilterOptions(temp)
								}}
							/>
						</div>
					</div>

					<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', width: '94%', marginTop: 10}}>
						<label className={GeneralStyles.darkText} style={{width: 200}}>Property Category</label>
						<div
							className={GeneralStyles.boxShadow}
							style={{width: '70%', minHeight: 40, borderRadius: 10, marginLeft: 10,}}>
							<CustomSelect
								isMulti={true}
								isSearchable={false}
								placeholder={'select'}
								borderColor={'transparent'}
								value={fieldFilterOptions[2].filter}
								options={propertyCategoryOptions}
								onChange={(selected) => {
									let temp = [...fieldFilterOptions]
									temp[2].filter = selected
									setFieldFilterOptions(temp)
								}}
							/>
						</div>
					</div>

					<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', width: '94%', marginTop: 10}}>
						<label className={GeneralStyles.darkText} style={{width: 200}}>Property Status</label>
						<div
							className={GeneralStyles.boxShadow}
							style={{width: '70%', minHeight: 40, borderRadius: 10, marginLeft: 10,}}>
							<CustomSelect
								isMulti={true}
								isSearchable={false}
								placeholder={'select'}
								borderColor={'transparent'}
								value={fieldFilterOptions[3].filter}
								options={propertyStatusOptions}
								onChange={(selected) => {
									let temp = [...fieldFilterOptions]
									temp[3].filter = selected
									setFieldFilterOptions(temp)
								}}
							/>
						</div>
					</div>

					<div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', width: '94%', marginTop: 10}}>
						<label className={GeneralStyles.darkText} style={{width: 200}}>State</label>
						<div
							className={GeneralStyles.boxShadow}
							style={{width: '70%', minHeight: 40, borderRadius: 10, marginLeft: 10,}}>
							<CustomSelect
								isMulti={true}
								isSearchable={true}
								placeholder={'select'}
								borderColor={'transparent'}
								value={fieldFilterOptions[5].filter}
								options={stateOptions}
								onChange={(selected) => {
									let temp = [...fieldFilterOptions]
									temp[5].filter = selected
									setFieldFilterOptions(temp)
								}}
							/>
						</div>
					</div>


					<div style={{position: 'absolute', bottom: 10, display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
						<CustomButtonContained
							text={'Apply Filter'}
							onClick={onSortConfirmed}
							style={{marginRight: 2}}
							color={'primary'}
						/>

						<CustomButtonContained
							style={{marginLeft: 2}}
							text={'Cancel'}
							onClick={() => setShowSortModal(false)}
							color={'secondary'}
						/>
					</div>

				</div>
			</CustomModal>
		)
	}

	const renderPagination = () => {
		let totalPages = tab === 0 ? newWorkOrdersPageCount : tab === 1 ? engagingWorkOrdersPageCount : ignoredWorkOrdersPageCount
		return (
			<div style={{marginTop: 2, width: '100%', display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
				<div style={{width: 200}}>
					<ResponsivePagination
						current={currentPage}
						total={totalPages}
						onPageChange={(page) => {
							setCurrentPage(page)
						}}
					/>
				</div>
			</div>
		)
	}

	const renderContent = () => {
		return (
			<div style={{height: '90vh'}}>
				{renderFilterRow()}
				{renderList()}
				{renderPagination()}

				{renderSearchModal()}
				{renderSortModal()}
			</div>
		)
	}


	return (
		<div className={GeneralStyles.container}>
			<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', position: 'relative' }}>
				<PageHeader header={'Work Orders'} />
				{/*<CustomButtonContained*/}
				{/*	text={'+ New Reservation'}*/}
				{/*	onClick={onNewReservationClicked}*/}
				{/*	style={{position: 'absolute', right: 40, zIndex: 10}}*/}
				{/*	color={showOverlay ? 'white' : 'primary'}*/}
				{/*/>*/}
			</div>

			<PositionedSnackbar
				onClose={() => {
					setShowError(false)
					setErrorMessage('')
				}}
				severity={'error'}
				openFlag={showError}
				message={errorMessage}
			/>

			{
				loading ?
					<div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%'}}>
						<CustomLoaderSpinner />
					</div>
					:
					renderContent()
			}
		</div>
	);
}

const Tab = ({tab, onChange}) => {
	return (
		<div style={{width: '90%', display: 'flex', flexDirection: 'row', alignItems: 'center', borderRadius: 10, border: '1px solid gray', padding: 4, backgroundColor: Colors.theme, borderColor: Colors.theme}}>
			<div
				className={Styles.tabEntry}
				style={{backgroundColor: tab === 0 ? Colors.tabButtonTheme : 'transparent',}}
				onClick={() => onChange(0)}>
				<p style={{fontSize: Constants.entryTextSize, color: Colors.tertiaryTextColor}}>New</p>
			</div>
			<div
				className={Styles.tabEntry}
				style={{backgroundColor: tab === 1 ? Colors.tabButtonTheme : 'transparent',}}
				onClick={() => onChange(1)}>
				<p style={{fontSize: Constants.entryTextSize, color: Colors.tertiaryTextColor}}>Engaging</p>
			</div>
			<div
				className={Styles.tabEntry}
				style={{backgroundColor: tab === 2 ? Colors.tabButtonTheme : 'transparent',}}
				onClick={() => onChange(2)}>
				<p style={{fontSize: Constants.entryTextSize, color: Colors.tertiaryTextColor}}>Ignored</p>
			</div>
		</div>
	)
}

const Header = ({title, width, marginLeft, sortOrder}) => {
	// const getIcon = () => {
	// 	if(sortOrder === 1)
	// 		return <ArrowUpwardIcon style={{color: 'white', width: 20, height: 20}}/>
	// 	else if(sortOrder === -1)
	// 		return <ArrowDownwardIcon style={{color: 'white', width: 20, height: 20}}/>
	// 	else
	// 		return null
	// }

	return (
    <div style={{width: width, display: 'flex', flexDirection: 'row', alignItems: 'center', backgroundColor: Colors.theme, color: 'white', fontWeight: 600, height: 34, marginLeft: marginLeft || 0}}>
      <p style={{fontSize: 15, fontWeight: 'bold', width: '100%', textAlign: 'left', color: Colors.tertiaryTextColor, marginLeft: 5}}>{title}</p>
    </div>
  )
}

const ListItem = ({title, width, marginLeft, breakWord}) => {
	return (
		<div style={{width: width, display: 'flex', flexDirection: 'row', alignItems: 'center',  color: 'white', marginLeft: marginLeft || 0}}>
			{
				breakWord ?
					<p style={{fontSize: Constants.entryTextSize, width: '100%', textAlign: 'left', color: Colors.primaryTextColor, marginLeft: 5, wordBreak: 'break-all', whiteSpace: 'normal'}}>{title}</p>
					:
					<p style={{fontSize: Constants.entryTextSize, width: '100%', textAlign: 'left', color: Colors.primaryTextColor, marginLeft: 5}}>{title}</p>
			}
		</div>
	)
}

const Status = ({status, marginLeft, width}) => {

	const getColor = () => {
		if(status === WORK_ORDER_STATUSES.NEW)
			return Colors.newWorkOrderColor
    else if(status === WORK_ORDER_STATUSES.ENGAGING)
			return Colors.engagingWorkOrderColor
		else if(status === WORK_ORDER_STATUSES.IGNORED)
			return Colors.ignoredWorkOrderColor
	}
	return (
		<div style={{width: width, display: 'flex', flexDirection: 'row', alignItems: 'center', color: 'white',  height: 34, marginLeft: marginLeft || 0}}>
			<p style={{fontSize: 13, width: '80%', textAlign: 'center', color: Colors.tertiaryTextColor, marginLeft: 5,  backgroundColor: getColor(), borderRadius: 10}}>{status}</p>
		</div>
	)
}
